export default __webpack_public_path__ + "static/media/not-avaliable.a69b847b.svg";